export function scrollTop(scrollElement) {
  const trackScroll = () => {
    const scrollOffset = window.pageYOffset
    const baseHeight = 400

    if (scrollOffset > baseHeight) {
      scrollElement.classList.add('active')
    }
    if (scrollOffset < baseHeight) {
      scrollElement.classList.remove('active')
    }
  }

  const backToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' })
  }

  window.addEventListener('scroll', trackScroll)
  scrollElement.addEventListener('click', backToTop)
}
